import { useState, useRef, useEffect } from "react";
import PlanCards from "../../Configs/JSON/PlanTypes.json";
import "./PlanTypes.less";
import Image from "../Common/Image/Image";
import AppStore from "../../Configs/Store/index";
const PlanTypes = () => {
  const [activeCard, setActiveCard] = useState(1);
  const Plans = PlanCards.cardContents;

  const cardRefs = useRef([]);
  const isMobile = AppStore.device !== 1;
  const isFirstRender = useRef(true); // Will stop from autoscrolling for the first mount

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (cardRefs.current[activeCard]) {
      cardRefs.current[activeCard].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeCard]);

  return (
    <div className="PlanTypesParent">
      <div className="PlanTypesMain">
        <h2 className="PlanTypesTitle">
          What are the different Types of Pension Plans available in India?
        </h2>
        <div className="PlanTypesSubTitle">
          Below listed are a few pension plan options available in India you can choose from<sup>1</sup>:
        </div>

        <div className="PlanTypesContainer">
          {Plans.map((item, index) => {
            const isActive = index === activeCard;
            return (
              <div className={`PlanTypesCardsHead`} key={index}>
                <div
                  ref={(el) => (cardRefs.current[index] = el)}
                  className={`PlanTypesCards ${isActive ? "active" : ""}`}
                  onClick={() => setActiveCard(index)}
                >
                  <Image
                    src={item.icon}
                    className="CardIcon"
                    alt="Icon"
                    style={{
                      height: AppStore.device === 1 ? "50px" : "40px",
                      width: AppStore.device === 1 ? "50px" : "40px",
                    }}
                  />
                  <h3 className={`CardTitle ${isActive ? "active" : ""}`}>
                    {item.title}
                  </h3>
                  {isActive && !isMobile && (
                    <div className="CardContent" dangerouslySetInnerHTML={{__html:item.content}}/>
                  )}
                  <div className={`PlanTypesarrow ${isActive && "active"}`}>
                    &gt;
                  </div>
                </div>
                {isActive && isMobile && <div className="PlanTypesseperator"></div>}
                {isActive && isMobile && <div className="PlanTypesMobileContent" dangerouslySetInnerHTML={{__html:item.content}}/>}
              </div>
            );
          })}
        </div>

        <div className="PlanTypesDots">
          {Plans.map((_, index) => {
            const isActive = index === activeCard;
            return (
              <div
                key={index}
                onClick={() => setActiveCard(index)}
                className={`PlanTypesDot ${isActive ? "active" : ""}`}
              ></div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PlanTypes;
